import _ from 'lodash'

export function camelCaseKey (key) {
  if (typeof key === 'string') {
    return key.split('.').map(_.camelCase).join('.')
  } else {
    return ''
  }
}
